const handleBasicData = (state = {}, action) => {
    switch (action.type) {
      case 'SET_BASIC':
        return state  = action.data;
      default:
        return state;
    }
  };
  
  export default handleBasicData;